var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._b({ref:"field",attrs:{"type":"hidden"}},'input',_vm.options.attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }